import React, { useState, useRef, useContext } from 'react';

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';

// ------------------ COMPONENTES DE BASE --------------------------------
import AgGrid from '../../../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../../../Base/Components/Loader/Loader';
import { AuthContext } from '../../../../../../Base/Context/AuthContext/AuthContext';

// ------------------- CONSULTAS A LA API --------------------------------
import { getOrdenesEncabezado, getOrdenesEncabezadoParaServicios } from '../../../../../../API/Compras/Ordenes/OrdenesComprasRequests';

const OverlayOC = ({onChange, detalles, close, Servicios, MateriaPrima}) => {

    const op = useRef(null);
    const buttom = useRef(null)
    const [loading, setLoading] = useState(false);
    const [ordenesC, setOrdenesC] = useState([]);

    const { userAuth } = useContext(AuthContext)
    const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth?.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));

    const obtenerOrdeneC = async () => {
        setLoading(true)
        let ordenesTempo
        console.log("=== OVERLAY OC ===");
        console.log("Servicios:", Servicios);
        console.log("MateriaPrima:", MateriaPrima);
        if (Servicios) {
            ordenesTempo = await getOrdenesEncabezadoParaServicios();
        } else {
            ordenesTempo = await getOrdenesEncabezado(MateriaPrima);
        }
        console.log("Ordenes recibidas:", ordenesTempo);
        console.log("==================");
        setOrdenesC(ordenesTempo)
        setLoading(false)
    }

    const colums = [
        {
            field: 'IdPurchaseOrder',
            header: 'ID',
            headerEn: 'ID',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1,
            frozen:true,
        },
        {
            field: 'PurchaseOrder',
            header: 'OC',
            headerEn: 'PO',
            className: 'Xsmall',
            Sumary: 'count',
            frozen:true,
        },
        {
            field: 'Expr1',
            header: 'Proveedor',
            headerEn: 'Customer',
            className: 'large',
        },
        {
            field: 'UserNameAgente',
            header: 'Agente',
            headerEn: 'Agent',
            className: 'medium',
        },
        {
            field: 'Area',
            header: 'Area',
            headerEn: 'Area',
            className: 'medium',
        },
        {
            field: 'Description',
            header: 'Comentario',
            headerEn: 'Comment',
            className: 'large',
        },
        {
            field: 'Currency',
            header: 'Moneda',
            headerEn: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'SubTotal',
            header: 'SubTotal',
            headerEn: 'SubTotal',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'ISVTotal',
            hidden: hiddenPriceColumn,
            header: 'ISV',
            headerEn: 'TAX',
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'Discount',
            hidden: hiddenPriceColumn,
            header: 'Desc.',
            headerEn: 'Disc.',
            Format: 'Currency',
            className: 'Xsmall',
        },
        {
            field: 'Total',
            header: 'Total',
            headerEn: 'Total',
            hidden: hiddenPriceColumn,
            Format: 'Currency',
            className: 'Xsmall',
        },
    ]

    const table = {
        Data: ordenesC,
        Columns: colums,
        onCellClicked: e => onChange(e, op)
    }

    const openOver = (e) => {
        op.current.toggle(e)
        setLoading(true)
        obtenerOrdeneC()
    }

    return (
        <div style={{ maxWidth: '55vw' }}>

            <div className="p-inputgroup">
                <Button ref={buttom} icon='pi pi-chevron-down' type="button" onClick={(e) => openOver(e)} disabled={detalles?.length > 0}/>
            </div>

            <OverlayPanel ref={op} showCloseIcon dismissable={false} onHide={close} style={{ height: '30vh', width: '42vw' }} >
                <Loader loading={loading} querySelector={'#ProveedoresCAIS'} />
                <div style={{ width: '40vw', height: '30vh' }} id='ProveedoresCAIS'>
                    <AgGrid table={table} />
                </div>
            </OverlayPanel>
        </div>
    )
}

export default OverlayOC